import * as React from 'react';

import { useSelector } from 'react-redux';

import { Button, ButtonContainer, Grid, Link, Spacer, Typography } from '@emburse/ui-core';

import { IAppStateContainer } from '@ReactStore/reducers';

import { checkIfBillingPlanIsAmex } from '@Shared/helpers/company';

interface ISignUpWorkflowFooter {
  onNext?: () => void;
  onBack?: (navDirection: 'next' | 'back') => void;
  isSubmitting?: boolean;
  showSupportLink?: boolean;
  hideButtons?: boolean;
  ariaLabel: string;
}

export const SignUpWorkflowFooter: React.FC<ISignUpWorkflowFooter> = ({
  onNext,
  onBack,
  showSupportLink,
  hideButtons,
  isSubmitting,
  ariaLabel
}) => {
  const company = useSelector((state: IAppStateContainer) => state.company.company);
  const isAmex = checkIfBillingPlanIsAmex(company.billing_plan);
  const spendHelpLink = 'https://help.spend.emburse.com/hc/en-us/articles/30064786381197-Signing-Up-for-Emburse-Spend';
  const amexHelpLink = 'https://help.spend.emburse.com/hc/en-us/articles/30065656820749-Sign-Up-for-Emburse-Spend-with-American-Express';

  const baseAriaLabel = showSupportLink ? `signup-${ariaLabel}` : ariaLabel;
  let helpLink;
  const whitelabelConfiguration = window.whitelabelConfiguration;
  if (whitelabelConfiguration && whitelabelConfiguration.id === 'SVB') {
    helpLink = whitelabelConfiguration?.supportLinks?.supportHome || spendHelpLink;
  } else {
    helpLink = isAmex ? amexHelpLink : spendHelpLink;
  }

  if (helpLink.endsWith('/')) {
    helpLink = helpLink.slice(0, -1);
  }

  return (
    <Grid container direction="column" alignContent={showSupportLink ? 'center' : 'flex-start'} alignItems={'center'} spacing={3}>
      {showSupportLink && (
        <Grid item>
          <Typography variant="caption">
            Need help? Visit our{' '}
            <Link href={helpLink} target="_blank" rel="noopener" className={`${baseAriaLabel}-help-link`}>
              Help Center
            </Link>{' '}
            for any questions.
          </Typography>
        </Grid>
      )}
      {!hideButtons && (
        <Grid item>
          <ButtonContainer>
            {onBack && (
              <Button variant="outlined" onClick={() => onBack('back')} className={`${baseAriaLabel}-back`} disabled={isSubmitting}>
                Previous
              </Button>
            )}
            {onNext && (
              <Button onClick={onNext} disabled={isSubmitting} className={`${baseAriaLabel}-next`}>
                {showSupportLink ? 'Next' : 'Save'}
              </Button>
            )}
          </ButtonContainer>
        </Grid>
      )}
      <Grid item>
        <Spacer size={3} />
      </Grid>
    </Grid>
  );
};
